import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

/** Resolve username or email input to the email used for Firebase Auth sign-in. */
export async function resolveLoginEmail(trimmedInput: string): Promise<{
  emailToUse: string;
  isUsername: boolean;
}> {
  let isUsername = false;
  let usernameToLookup = '';

  if (trimmedInput.startsWith('@')) {
    isUsername = true;
    usernameToLookup = trimmedInput.substring(1).trim();
  } else if (trimmedInput.includes('@')) {
    isUsername = false;
  } else {
    isUsername = true;
    usernameToLookup = trimmedInput;
  }

  let emailToUse = trimmedInput.toLowerCase();

  if (isUsername) {
    try {
      const getEmailForUsername = httpsCallable<
        { username: string },
        { found: boolean; email: string | null }
      >(functions, 'getEmailForUsername');
      const result = await getEmailForUsername({ username: usernameToLookup });
      const data = result.data;
      if (data.found && data.email) {
        emailToUse = data.email;
      } else {
        emailToUse = `${usernameToLookup.toLowerCase()}@six-tool.web.app`;
      }
    } catch {
      emailToUse = `${usernameToLookup.toLowerCase()}@six-tool.web.app`;
    }
  }

  return { emailToUse, isUsername };
}
